module.exports = __webpack_public_path__ + "img/paste.3f425500.svg";